module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auto"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/one.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("多平台适用")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("DUO PING TAI SHI YONG")]), _vm._v(" "), _c('div', {
    staticClass: "labels"
  }, [_c('div', {
    staticClass: "label-item"
  }, [_vm._v("1、匹配国内有美团、饿了么、京东到家等多平台同步开店的需求，连接多个平台只需一台打印机。")]), _vm._v(" "), _c('div', {
    staticClass: "label-item"
  }, [_vm._v("2、同时无需人工值守，避免人工操作导致的接单混乱等意外。")]), _vm._v(" "), _c('div', {
    staticClass: "label-item"
  }, [_vm._v("3、自主开放平台支持第三方平台接口对接，无平台接入数量限制。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6cc8026"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homePage1.vue
// module id = 351
// module chunks = 1